'use strict';

const scrollAnimate = require('base/components/scrollAnimate');
const wishlist = require('../product/wishlist');
const addProductToWishlistStorage = wishlist.methods.addProductToWishlistStorage;

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    const $lineItem = $('.uuid-' + uuid);
    const $productImg = $lineItem.find('.cart-lineitem-image').clone();
    const $productPrice = $lineItem.find('.cart-lineitem-price').clone();
    const $successRemoveProductModal = $('.success-remove-product-modal');

    const $deleteConfirmBtn = $('.cart-delete-confirmation-btn');

    $deleteConfirmBtn.attr('data-pid', productID);
    $deleteConfirmBtn.attr('data-action', actionUrl);
    $deleteConfirmBtn.attr('data-uuid', uuid);

    $('.remove-product-modal .product-to-remove').empty().append(productName);
    $('.remove-product-modal .product-to-remove-img').empty().append($productImg);
    $('.remove-product-modal .product-to-remove-price').empty().append($productPrice);
    if ($successRemoveProductModal.length) {
        $successRemoveProductModal.find('.product-name').empty().append(productName);
        $('body').trigger('removeProduct:success');
    }
}

/**
 * Updates the cart top message container with limit messages.
 * @param {string[]} limitMessages - An array of messages to display in the cart top message container.
 */
function updateLimitMessages(limitMessages) {
    if (limitMessages) {
        const $cartProductLimit = $('.cart-top-product-limit');
        $cartProductLimit.empty();
        if (limitMessages.length) {
            limitMessages.forEach(function (msg) {
                $cartProductLimit.append(`<p>${msg}</p>`);
            });
            scrollAnimate($('.cartmain'));
        }
    }
}

/**
 * Appends query parameters to a given URL.
 *
 * @param {string} url - The base URL.
 * @param {Object} params - An object containing key-value pairs to append.
 * @returns {string} - The updated URL with appended query parameters.
 */
function appendToUrl(url, params) {
    const queryString = Object.keys(params)
        .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
        .join('&');

    return url + (url.includes('?') ? '&' : '?') + queryString;
}

/**
 * Updates the quantity in UI.
 */
function updateQuantityUI() {
    $('.cart-lineitem-qty-wrapper').each(function () {
        const $container = $(this);
        const inputVal = $container.find('.quantity').val();
        if (inputVal) {
            $container.find('.cart-lineitem-qty-value').text(inputVal);
        }
    });
}

/**
 * Validates the basket and updates the UI accordingly.
 * If the basket is invalid, it displays an error message and disables the checkout button.
 *
 * @param {Object} data - The AJAX response from the server.
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            const errorHtml = `
                <div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                    ${data.valid.message}
                </div>
            `;
            $('.cart-error').append(errorHtml);
        } else {
            const emptyCartHtml = `
                <div class="row">
                    <div class="col-12 text-center">
                        <h1>${data.resources.emptyCartMsg}</h1>
                    </div>
                </div>
            `;
            $('.cart').empty().append(emptyCartHtml);
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems,
            });
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the Shipping totals in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateShippingTotals(data) {
    const $shippingCost = $('.shipping-cost');
    const totals = data.totals || (data.basket && data.basket.totals);
    if (totals) {
        if (totals.adjustedShippingTotalPrice && totals.adjustedShippingTotalPrice.value === 0) {
            const freeMsg = $shippingCost.attr('data-free-ship-msg');
            $shippingCost.empty().append(freeMsg);
        } else if (totals.adjustedShippingTotalPrice && totals.adjustedShippingTotalPrice.value > 0) {
            $shippingCost.empty().append(totals.adjustedShippingTotalPrice.formatted);
        } else {
            $shippingCost.empty().append(totals.totalShippingCost);
        }
    }

    if (totals && totals.shippingLevelDiscountTotal && totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-without-discount-total').empty().append(totals.totalShippingCost);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.cart-title-wrapper .cart-count .count-text').empty().append(data.numItems);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.subTotal);
    $('.sub-total-discount').empty().append(data.totals.subTotalDiscounted);

    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems,
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total')
            .empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }
    updateShippingTotals(data);

    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID)
                .empty()
                .append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price')
            .empty()
            .append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price')
            .empty()
            .append(item.renderedPrice);
        $('.item-total-' + item.UUID)
            .empty()
            .append(item.priceTotal.renderedPrice);
    });
}

/**
 * Displays an error notification in the cart.
 *
 * @param {string} message - The error message to display.
 */
function createErrorNotification(message) {
    const errorHtml = `
        <div class="alert alert-danger alert-dismissible valid-cart-error fade show" role="alert">
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            ${message}
        </div>
    `;

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    var $approachingDiscounts = $('.approaching-discounts');
    $approachingDiscounts.empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">' + item.discountMsg + '</div>';
        });
    }
    $approachingDiscounts.append(html);
}

module.exports = function () {
    const $document = $(document);
    const $body = $('body');
    const $window = $(window);
    const $promoModal = $('.promo-applied-successfully');
    const $lithiumBatterieEle = $('.lithium-batteries-msg').first();
    const specialMsgArray = [];

    if ($lithiumBatterieEle.length && $lithiumBatterieEle.data('top')) {
        specialMsgArray.push(`<p>${$lithiumBatterieEle.data('top')}</p>`);
    }

    $('.cart-lineitem-messages p').each(function () {
        const $this = $(this);
        if (!$this.hasClass('lithium-batteries-msg')) {
            const msg = `<p>${$this.html()}</p>`;
            if (!specialMsgArray.includes(msg)) {
                specialMsgArray.push(msg);
            }
        }
    });

    $('.special-message-region').append(specialMsgArray.join(''));

    updateQuantityUI();

    $body.on('cart:update promotion:success', function (e, data) {
        const tempData = 'basket' in data ? data.basket : data;
        if (tempData.cartLineItemsHtml) {
            $('.cart-left-wrapper').html(tempData.cartLineItemsHtml);
        }

        if ('totals' in tempData && 'discountsHtml' in tempData.totals && tempData.totals.discountsHtml) {
            $('.promo-code-form .coupon-field-wrapper').empty().append($(tempData.totals.discountsHtml).html());
        }

        updateShippingTotals(data);
    });

    $body.on('cart:update', function (e, data) {
        updateQuantityUI();
        updateLimitMessages(data.limitMessages || null);
        if (data.basket && data.basket.valid && !data.basket.valid.error) {
            $('.cart-top-basket-limit').empty();
        }
        if (data.basket && data.basket.items.length !== 0) {
            $('.minicart-overlay-wrapper .count-text .ajax-count').html(data.basket.numItems);
        }
        if (data.numItems) {
            $('.cart-title-wrapper .cart-count .count-text').empty().append(data.numItems);
        }
        if (data.queryString) {
            const uuid = new URLSearchParams(data.queryString).get('uuid');
            const $incrementBtn = $(`.uuid-${uuid} .cart-lineitem-increment`);
            $incrementBtn.addClass('loading');
            setTimeout(function () {
                $incrementBtn.removeClass('loading');
            }, 1000);
        }
        $body.trigger('minicart:update');

        const $wishlistBtn = $('.cart-wishlist-confirmation-btn');
        if ($wishlistBtn.hasClass('active')) {
            $wishlistBtn.removeClass('active');
            const url = $wishlistBtn.data('addWishlistUrl');
            const pid = $wishlistBtn.data('pid');
            $.ajax({
                url: url,
                type: 'POST',
                data: {
                    pid: pid,
                },
                success: function () {
                    $('.wishlist-confirmation-modal').modal('hide');
                    $('.cart-wishlist-success-modal').modal('show');
                    addProductToWishlistStorage(pid);
                },
                error: function () {
                    $('.wishlist-confirmation-modal').modal('hide');
                },
            });
        }
        if (data.basket && data.basket.items.length === 0) {
            if (!$('.minicart').hasClass('minicart-open')) {
                addProductToWishlistStorage($wishlistBtn.data('pid'));
                window.location.reload();
            }
        }
    });

    $document.on('ajaxComplete', function (event, xhr) {
        updateLimitMessages(xhr.responseJSON && xhr.responseJSON.limitMessages ? xhr.responseJSON.limitMessages : null);
    });

    $document.on('click', '.cart-lineitem-increment', function () {
        $(this).closest('.cart-lineitem-qty-wrapper').find('.quantity').val(1).change();
    });

    $document.on('click', '.cart-lineitem-multi-increment', function () {
        let element = $(this);
        let dialogUrl = element.data('dialogUrl');
        $.ajax({
            url: dialogUrl,
            type: 'get',
            success: function (data) {
                let newModal = $(data);
                element.closest('.cart-lineitem-qty-wrapper').after(newModal);
                $('#newQtyBox').modal('show');
                $('#newQtyBox').on('hidden.bs.modal', function () {
                    let newQty = $('#newQtyBox').find('#newQtyValue').val();
                    if (parseInt(newQty, 10)) {
                        element.closest('.cart-lineitem-qty-wrapper').find('.quantity').val(newQty).change();
                    }
                    $('#newQtyBox').remove();
                });
            },
        });
    });

    $body.on('removeProduct:success', function () {
        const $successRemoveProductModal = $('.success-remove-product-modal');
        $successRemoveProductModal.modal('show');
        $successRemoveProductModal.addClass('show');
        if ($successRemoveProductModal.hasClass('show')) {
            $('.modal-backdrop').addClass('success-remove-product-modal-open');
        }
    });

    $body.on('click', '.delete-coupon-confirmation-btn', function () {
        $promoModal.addClass('promo-remove-model');
    });

    $promoModal.on('hidden.bs.modal', function () {
        $promoModal.removeClass('promo-remove-model');
    });

    $body.on('promotion:error', function (e, data) {
        $('.promo-error-modal').modal('show');
        $promoModal.removeClass('promo-remove-model');
        if (data.queryString) {
            const couponCode = new URLSearchParams(data.queryString).get('couponCode');
            if (couponCode) {
                setTimeout(function () {
                    $('.coupon-code-field').val(couponCode);
                }, 0);
            }
        }
    });

    $body.on('promotion:success', function (e, data) {
        const discounts = data?.totals?.discounts || [];
        const $deletePromoBtn = $('.delete-coupon-confirmation-btn');
        const $couponInput = $('.coupon-code-field');
        const $promoCodeBtn = $('.promo-code-btn');

        let couponCode = '';
        let uuid = '';

        if (discounts.length) {
            const discountFound = discounts.find((discount) => discount.type === 'coupon' && discount.applied);
            if (discountFound) {
                couponCode = discountFound.couponCode || '';
                uuid = discountFound.UUID || '';
            }
        }

        $deletePromoBtn.toggleClass('d-none', !couponCode);
        $promoCodeBtn.prop('disabled', !!couponCode);
        setTimeout(function () {
            $couponInput.prop('disabled', !!couponCode).val(couponCode);
        }, 0);
        $deletePromoBtn.data({ code: couponCode, uuid: uuid });

        $promoModal.modal('show');

        if (data.totals && data.totals.subTotalDiscounted && data.totals.subTotal) {
            $('.sub-total-discount')
                .text(data.totals.subTotalDiscounted)
                .toggleClass('hide-shipping-discount', data.totals.subTotal === data.totals.subTotalDiscounted);
            $('.sub-total')
                .text(data.totals.subTotal)
                .toggleClass('text-decoration-line-through lr-m', data.totals.subTotal !== data.totals.subTotalDiscounted);
        }
    });

    $body.on('input', '.coupon-code-field', function () {
        const $this = $(this);
        if ($this.val()) {
            $this.removeClass('is-invalid');
        }
    });

    $('.promo-code-form').submit(function () {
        if (!$('.coupon-code-field').val()) {
            $('.promo-error-modal').modal('show');
        }
    });

    $body.on('click', '.clear-cupon-code', function () {
        $('.coupon-code-field').val('').removeClass('is-invalid');
    });

    $body.off('click', '.remove-product').on('click', '.remove-product', function (e) {
        e.preventDefault();
        const $this = $(this);

        var actionUrl = $this.data('action');
        var productID = $this.data('pid');
        var productName = $this.data('name');
        var uuid = $this.data('uuid');

        $('body').trigger('gtm:hook', { targetGtmEl: $('.cart-delete-confirmation-btn'), productId: productID, context: 'REMOVE_FROM_CART' });
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $body.on('click', '.move-product-wishlist-link', function () {
        var uuid = $(this).attr('data-uuid');
        var productID = $(this).attr('data-pid');
        var actionUrl = $(this).attr('data-action');
        const $lineItem = $('.uuid-' + uuid);
        const $productImg = $lineItem.find('.cart-lineitem-image').clone();
        const productName = $lineItem.find('.cart-lineitem-name').text();
        const $wishListConfirmBtn = $('.cart-wishlist-confirmation-btn');
        $wishListConfirmBtn.attr('data-pid', productID);
        $wishListConfirmBtn.attr('data-uuid', uuid);
        $wishListConfirmBtn.attr('data-action', actionUrl);
        $('.cart-wishlist-success-modal .product-wishlist-img').empty().append($productImg);
        $('.cart-wishlist-success-modal .product-to-wishlist').empty().append(productName);
    });

    $body.on('click', '.cart-wishlist-confirmation-btn', function () {
        $(this).addClass('active');
    });

    $body.off('click', '.cart-delete-confirmation-btn').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();
        var $this = $(this);
        var productID = $this.attr('data-pid');
        var url = $this.attr('data-action');
        var uuid = $this.attr('data-uuid');
        var productName = $this.attr('data-name');
        var urlParams = {
            pid: productID,
            uuid: uuid,
        };
        url = appendToUrl(url, urlParams);
        $('body > .modal-backdrop').remove();
        $.spinner().start();
        $body.trigger('cart:beforeUpdate');
        $('.remove-product-modal').modal('hide');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems);
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems,
                    });
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                confirmDelete(url, productID, productName, uuid);
                $body.trigger('cart:update', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            },
        });
    });

    $body.off('click', '.add-refill-cta').on('click', '.add-refill-cta', function (e) {
        e.preventDefault();
        var $refillModalBody = $('#refillProducts .modal-body');
        $refillModalBody.empty();
        var $cta = $(this);
        var actionUrl = $cta.data('action');
        var productID = $cta.data('pid');
        var uuid = $cta.data('uuid');

        $.spinner().start();

        $.ajax({
            url: actionUrl,
            type: 'get',
            data: { pid: productID, uuid: uuid },
            success: function (result) {
                var $html = $('<div>').append($.parseHTML(result.renderedTemplate));
                var $newModalData = $html.find('.modal-body');
                $refillModalBody.html($newModalData.html());
                $('#refillProducts').modal('show');

                $('.refill-products-modal .product-carousel').each(function () {
                    var $this = $(this);
                    if (!$this.hasClass('slick-initialized')) {
                        $this.slick({
                            dots: true,
                            arrows: false,
                            infinite: false,
                            lazyLoad: 'ondemand',
                            slidesToShow: 3.5,
                            speed: 500,
                            touchThreshold: 100,
                            slidesToScroll: 1,
                            nextArrow: '<button type="button" class="slick-next"><i class="icon icon-arrow-right-icon"></i></button>',
                            prevArrow: '<button type="button" class="slick-prev"><i class="icon icon-arrow-left-icon"></i></button>',
                            responsive: [
                                {
                                    breakpoint: 1024,
                                    settings: {
                                        slidesToShow: 2.7,
                                        slidesToScroll: 1,
                                    },
                                },
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 1.4,
                                        slidesToScroll: 1,
                                    },
                                },
                            ],
                        });
                    }
                });
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            },
        });
    });

    $body.off('click', '.refill-products-modal .add-to-cart').on('click', '.refill-products-modal .add-to-cart', function (e) {
        e.preventDefault();
        var $this = $(this);
        var actionUrl = $this.data('action');
        var productID = $this.data('formPid');
        var quantity = $this.data('formQuantity');
        var addAgainCta = $this.data('addAgainCta');

        $.spinner().start();

        $.ajax({
            url: actionUrl,
            type: 'post',
            data: { pid: productID, quantity: quantity },
            success: function (response) {
                if (!response.error) {
                    const $productAddSuccess = $this.closest('.product-tile-body').find('.success-msg-block');
                    if ($productAddSuccess.hasClass('d-none')) {
                        $productAddSuccess.removeClass('d-none');
                    } else {
                        $productAddSuccess.addClass('d-none');
                        setTimeout(function () {
                            $productAddSuccess.removeClass('d-none');
                        }, 100);
                    }
                    $this.fadeOut(100, function () {
                        $this.html(addAgainCta).fadeIn(100);
                    });
                    $('.minicart').trigger('count:update', response);
                    $('.refill-products-modal').attr('data-product-added', 'true');
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON && err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
                $.spinner().stop();
            },
        });
    });

    $('#refillProducts').on('hide.bs.modal', function () {
        if ($(this).attr('data-product-added') === 'true') {
            window.location.reload();
        }
    });

    $body.on('change', '.js-giftwrap-checkbox', function () {
        const $this = $(this);
        const $modal = $('#cartGiftWrappingModal');
        const currentVal = $this.prop('checked');
        const isEditMode = !currentVal === true;

        // undo the effect, wait for the modal submit/close to happen
        $this.prop('checked', !currentVal);

        $('input[name="UUID"]', $modal).val($this.attr('data-uuid'));
        $('#cartGiftWrappingMessage', $modal).val(isEditMode ? decodeURIComponent($this.attr('data-text') || '') : '');
        $('#cartGiftWrappingFreeWrap', $modal).prop('checked', isEditMode ? $this.attr('data-has-free-gift-wrap') === 'true' : true);

        if (isEditMode) {
            $('.js-remove-gift-wrap', $modal).removeClass('d-none');
        } else {
            $('.js-remove-gift-wrap', $modal).addClass('d-none');
        }

        $modal.modal('show');
    });

    $body.on('click', '.js-edit-giftwrap', function (e) {
        e.preventDefault();
        $(this).closest('label').siblings('.js-giftwrap-checkbox').prop('checked', false).trigger('change');
    });

    $('#cartGiftWrappingModal')
        .off('click', '.js-remove-gift-wrap')
        .on('click', '.js-remove-gift-wrap', function (e) {
            const $this = $(this);
            const $modal = $this.closest('#cartGiftWrappingModal');
            e.preventDefault();
            const UUID = $('input[name="UUID"]', $modal).val();

            $.ajax({
                url: $this.attr('data-remove-url'),
                method: 'POST',
                data: {
                    UUID,
                },
                success: function () {
                    const $input = $(`.js-giftwrap-checkbox[data-uuid="${UUID}"]`);
                    $input.prop('checked', false);
                    $modal.modal('hide');
                },
            });
        });

    $('#cartGiftWrappingModal form').on('submit', function (e) {
        e.preventDefault();
        const $this = $(this);
        const $modal = $this.closest('#cartGiftWrappingModal');
        const url = $this.attr('action');

        $.ajax({
            url,
            method: 'POST',
            data: $this.serialize(),
            success: function (response) {
                if (response.success && response.data) {
                    const UUID = response.data.UUID;
                    const $input = $(`.js-giftwrap-checkbox[data-uuid="${UUID}"]`);
                    if (response.data.giftMessage) {
                        $input.attr('data-text', encodeURIComponent(response.data.giftMessage));
                    }
                    $input.attr('data-has-free-gift-wrap', response.data.freeGiftWrap);
                    $input.prop('checked', true);

                    $('body').trigger('gtm:add:event', response);
                }
                $modal.modal('hide');
            },
        });
    });

    $('.js-cart-gift-wrap-message')
        .off('keyup', '#cartGiftWrappingMessage')
        .on('keyup', '#cartGiftWrappingMessage', function () {
            let $this = $(this);
            let $parent = $this.closest('.js-cart-gift-wrap-message');
            let length = $this.val().length;
            let maxlength = parseInt($this.attr('maxlength'), 10);

            $('.instructions-text span', $parent).html(maxlength - length);
        });

    const $cartSummaryWrapper = $('.cart-right-container');
    if ($('.cart-summary-toggle').length || $cartSummaryWrapper.length) {
        const cartEl = $cartSummaryWrapper[0];
        const observer = new IntersectionObserver(
            ([entry]) => {
                const viewportHeight = window.outerHeight;
                const windowTop = window.scrollY || window.pageYOffset;
                const containerOffset = $cartSummaryWrapper.offset().top;

                // If it's not fully visible and on small screens, make it sticky
                const isSticky = !entry.isIntersecting && (app.isMobile() || app.isTablet());
                $cartSummaryWrapper.toggleClass('sticky-cart-summary', isSticky);
                if (windowTop + viewportHeight > containerOffset + 100) {
                    $cartSummaryWrapper.removeClass('sticky-cart-summary');
                }
            },
            {
                root: null,
                threshold: 0.01,
            }
        );
        observer.observe(cartEl);
        // Toggle active class on click
        $document.on('click', '.cart-summary-toggle', function () {
            $(this).closest('.cart-right-container').toggleClass('active');
        });
        // Handle responsive changes
        $window.on('resize', function () {
            observer.unobserve(cartEl);
            observer.observe(cartEl);
        });
    }

    $('.promo-code-form')
        .off('submit')
        .on('submit', function (e) {
            e.preventDefault();
            $.spinner().start();
            $('.coupon-missing-error').hide();
            $('.coupon-error-message').empty();
            if (!$('.coupon-code-field').val()) {
                $('.promo-code-form .form-control').addClass('is-invalid');
                $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
                $('.coupon-missing-error').show();
                $.spinner().stop();
                return false;
            }
            var $form = $('.promo-code-form');
            $('.promo-code-form .form-control').removeClass('is-invalid');
            $('.coupon-error-message').empty();
            $('body').trigger('promotion:beforeUpdate');

            $.ajax({
                url: $form.attr('action'),
                type: 'GET',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (data.error) {
                        $('.promo-code-form .form-control').addClass('is-invalid');
                        $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                        $('.coupon-error-message').empty().append(data.errorMessage);
                        $('body').trigger('promotion:error', data);
                    } else {
                        $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                        updateCartTotals(data);
                        updateApproachingDiscounts(data.approachingDiscounts);
                        validateBasket(data);
                        $('body').trigger('promotion:success', data);
                    }
                    $.spinner().stop();
                },
                error: function (err) {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
            return false;
        });

    $('body')
        .off('click', '.delete-coupon-confirmation-btn')
        .on('click', '.delete-coupon-confirmation-btn', function (e) {
            e.preventDefault();

            var url = $(this).data('action');
            var uuid = $(this).data('uuid');
            var couponCode = $(this).data('code');
            var urlParams = {
                code: couponCode,
                uuid: uuid,
            };

            url = appendToUrl(url, urlParams);

            $('body > .modal-backdrop').remove();

            $.spinner().start();
            $('body').trigger('promotion:beforeUpdate');
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    $('.coupon-uuid-' + uuid).remove();
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $.spinner().stop();
                    $('body').trigger('promotion:success', data);
                },
                error: function (err) {
                    $('body').trigger('promotion:error', err);
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                },
            });
        });
};
